import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const useEmulator = import.meta.env.VITE_FIREBASE_USE_EMULATOR === "true";

export const IS_MOCK_AUTH = import.meta.env.VITE_USE_MOCK_DATA === "true";

let app: FirebaseApp | undefined;
let authInstance: Auth | undefined;

export function getFirebaseApp(): FirebaseApp | undefined {
  if (typeof window === "undefined") return undefined;
  if (IS_MOCK_AUTH) return undefined;
  if (!app) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  }
  return app;
}

export function getFirebaseAuth(): Auth {
  if (IS_MOCK_AUTH) {
    throw new Error("Firebase Auth is disabled in mock mode");
  }
  const a = getFirebaseApp();
  if (!a) throw new Error("Firebase Auth is not available during SSR");
  if (!authInstance) {
    authInstance = getAuth(a);
    if (useEmulator) {
      connectAuthEmulator(authInstance, "http://localhost:9099", { disableWarnings: true });
    }
  }
  return authInstance;
}

export function getFirebaseDb(): Firestore {
  const a = getFirebaseApp();
  if (!a) throw new Error("Firestore is not available during SSR");
  return getFirestore(a);
}

export function getFirebaseStorage(): FirebaseStorage {
  const a = getFirebaseApp();
  if (!a) throw new Error("Firebase Storage is not available during SSR");
  return getStorage(a);
}